// extracted by mini-css-extract-plugin
export default {"menuBlock":"PM-z","title":"QM-z","nav":"RM-z","flexCell":"SM-z","facetLink":"TM-z"};